import { render, staticRenderFns } from "./BlockType26.vue?vue&type=template&id=20baf12e&scoped=true"
import script from "./BlockType26.vue?vue&type=script&lang=ts"
export * from "./BlockType26.vue?vue&type=script&lang=ts"
import style0 from "./BlockType26.vue?vue&type=style&index=0&id=20baf12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20baf12e",
  null
  
)

export default component.exports